<template>
    <v-container>
        <v-dialog scrollable v-model="dgBirim" width="700">


            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Birim Ağaçı
                </v-card-title>

                <v-card-text>
                    <v-treeview return-object v-model="selectedBirimIds" selectable :items="items"></v-treeview>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="btnBirimAdd()">
                        Düzenle
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="12">
                <v-text-field label="Bireysel Filtreleme"
                    hint="Öğrenci için öğrenci numarası,personel için eposta adresi ÖRN:2025010512,ahmetyayla  NOT:2025010512 öğrenci için,ahmetyayla personel için "
                    v-model="filterUser.custom"></v-text-field>
            </v-col>
            <v-divider></v-divider>
            <v-col cols="3" sm="3" md="3">
                Öğrenci Birimleri <v-icon large color="blue darken-2" dark
                    @click="birimChange(0)">mdi-file-edit</v-icon>
                <ul style="max-height: 250px;overflow-y: auto;">
                    <li v-for="ogrenciProgram in filterUser.ogrenciProgramIds" :key="ogrenciProgram.id">
                        {{ ogrenciProgram.name }}</li>
                </ul>



            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="3" sm="3" md="3">
                Akademi Birimleri <v-icon large color="blue darken-2" dark
                    @click="birimChange(1)">mdi-file-edit</v-icon>
                <ul style="max-height: 250px;overflow-y: auto;">
                    <li v-for="item in filterUser.pbsAkademisyenBirimIds" :key="item.id">{{ item.name }}</li>
                </ul>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="3" sm="3" md="3">
                İdari Birimler <v-icon large color="blue darken-2" dark @click="birimChange(2)">mdi-file-edit</v-icon>
                <ul style="max-height: 250px;overflow-y: auto;">
                    <li v-for="item in filterUser.pbsIdariBirimIds" :key="item.id">{{ item.name }}</li>
                </ul>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="3" sm="3" md="3">
                Diğer Birimler <v-icon large color="blue darken-2" dark @click="birimChange(3)">mdi-file-edit</v-icon>
                <ul style="max-height: 250px;overflow-y: auto;">
                    <li v-for="item in filterUser.pbsDigerBirimIds" :key="item.id">{{ item.name }}</li>
                </ul>
            </v-col>


        </v-row>
    </v-container>
</template>

<script>
import FilterUserService from '@/services/FilterUserService';
export default {
    name: 'HelloWorld',

    props: {

        value: {
            type: Object,
            default: () => {
                return {
                    custom: "",
                    ogrenciProgramIds: [],
                    pbsAkademisyenBirimIds: [],
                    pbsIdariBirimIds: [],
                    pbsDigerBirimIds: [],
                }
            }
        },
        

    },
    data: () => ({
        dgBirim: false,
        items: [],
        selectedBirimIds: [],
        selectedBirimTurId: 0,
        filterUser: {
            custom: "",
            ogrenciProgramIds: [],
            pbsAkademisyenBirimIds: [],
            pbsIdariBirimIds: [],
            pbsDigerBirimIds: [],
        },
    }),
    created() {

        this.dataBind();
    },
    methods: {
        btnBirimAdd() {
            if (this.selectedBirimTurId == 0) {
                this.filterUser.ogrenciProgramIds = this.selectedBirimIds;

            }
            if (this.selectedBirimTurId == 1) {
                this.filterUser.pbsAkademisyenBirimIds = this.selectedBirimIds;
            }
            if (this.selectedBirimTurId == 2) {
                this.filterUser.pbsIdariBirimIds = this.selectedBirimIds;
            }
            if (this.selectedBirimTurId == 3) {
                this.filterUser.pbsDigerBirimIds = this.selectedBirimIds;
            }
            this.$emit('input', this.filterUser);
            this.dgBirim = false;
        },
        birimChange(birimtur) {
            this.selectedBirimTurId = birimtur;
            if (this.selectedBirimTurId == 0) {
                FilterUserService.ObsBirimAgaci().then((result) => {
                    this.items = result.data;
                    this.dgBirim = true;
                    this.selectedBirimIds = this.filterUser.ogrenciProgramIds;
                }).catch((err) => {

                });
            } else {

                FilterUserService.PbsBirimAgaci(birimtur).then((result) => {
                    console.log("PbsBirimAgaci", result.data);
                    this.items = result.data;
                    this.dgBirim = true;
                    if (this.selectedBirimTurId == 1) {
                        this.selectedBirimIds = this.filterUser.pbsAkademisyenBirimIds;
                    }
                    if (this.selectedBirimTurId == 2) {
                        this.selectedBirimIds = this.filterUser.pbsIdariBirimIds;
                    }
                    if (this.selectedBirimTurId == 3) {
                        this.selectedBirimIds = this.filterUser.pbsDigerBirimIds;
                    }


                }).catch((err) => {

                });


            }


        },

        dataBind() {
            // console.log("dataBind", this.value);
            this.filterUser = JSON.parse(JSON.stringify(this.value));

            //this.filterUser = this.value;
            // FilterUserService.PbsPersonels().then((result) => {
            //     console.log("Personel:", result.data);
            //     this.personels = result.data;
            // }).catch((err) => {

            // });
        }


    },
    watch: {

        // selectedBirimIds: {
        //     immediate: true,
        //     handler(newVal, oldVal) {
        //         //         this.$nextTick(() => {
        //         //this.$emit('update:filter', this.filterUser);
        //         console.log("selectedBirimIds", newVal);
        //         this.$emit('input', this.filterUser);
        //         //   });



        //     },
        //     deep: true
        // },

        value: {
            immediate: true,
            handler(newVal, oldVal) {

  const newStr = JSON.stringify(newVal);
      const oldStr = JSON.stringify(this.filterUser);
      if (newStr !== oldStr) {
      this.filterUser = JSON.parse(JSON.stringify(newVal));
      }

               




            },
            deep: true
        },
          filterUser: {
            immediate: true,
            handler(newVal, oldVal) {

  const newStr = JSON.stringify(newVal);
      const oldStr = JSON.stringify(this.value);
      if (newStr !== oldStr) {
        this.$emit('input', newVal);
      }

                //this.filterUser = JSON.parse(JSON.stringify(newVal));
//  this.$emit('input', this.filterUser);



            },
            deep: true
        },


    }
}
</script>
